import { render, staticRenderFns } from "./UploadSmallImage.vue?vue&type=template&id=2c3049bf&"
import script from "./UploadSmallImage.vue?vue&type=script&lang=js&"
export * from "./UploadSmallImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports